import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from '../Tooltip';
const TruncateText = ({ text, enableCopy = false, className, startChars = 3, endChars = 3, }) => {
    const shouldTruncate = text.length > startChars + endChars;
    let truncatedText = text;
    if (shouldTruncate) {
        if (startChars === 0) {
            truncatedText = `...${text.slice(-endChars)}`;
        }
        else if (endChars === 0) {
            truncatedText = `${text.slice(0, startChars)}...`;
        }
        else {
            truncatedText = `${text.slice(0, startChars)}...${text.slice(-endChars)}`;
        }
    }
    const [copied, setCopied] = useState(false);
    const handleCopy = () => {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };
    return (_jsx(TooltipProvider, { children: _jsxs(Tooltip, { children: [_jsx(TooltipTrigger, { className: `cursor-${enableCopy ? 'pointer' : 'default'} select-none text-gray-700  hover:text-black transition`, onClick: enableCopy ? handleCopy : undefined, "aria-label": enableCopy ? 'Click to copy' : '', children: _jsx("span", { className: className, children: copied ? 'Copied' : truncatedText }) }), _jsx(TooltipContent, { className: "max-w-xs p-2 bg-gray-900 text-white rounded shadow-md text-sm", children: _jsx("p", { className: "whitespace-pre-wrap break-words", children: text }) })] }) }));
};
export default TruncateText;
